import { render, staticRenderFns } from "./PointTransactionHistory.vue?vue&type=template&id=2e10a8d9&scoped=true"
import script from "./PointTransactionHistory.vue?vue&type=script&lang=js"
export * from "./PointTransactionHistory.vue?vue&type=script&lang=js"
import style0 from "./PointTransactionHistory.vue?vue&type=style&index=0&id=2e10a8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e10a8d9",
  null
  
)

export default component.exports